module.exports = __webpack_public_path__ + "static/new-logo-2bc9b8c3e00c4c23f7a1fd0374c7bec1.png";